import API_CLIENT from "../../utils/Api";
import { buildPayload } from "../../utils/helper";

export const GetCoupons = async (page) => {
  return await API_CLIENT.get(`/coupons?page=${page}`);
};
export const CreateSingleCoupon = async (payload) => {
  const sanitizedPayload = buildPayload(payload);
  return await API_CLIENT.post("/coupons", sanitizedPayload);
};
export const DeleteCoupon = async (id) => {
  return await API_CLIENT.delete(`/coupons/${id}`);
};

export const GetSingleCoupon = async (id) => {
  return await API_CLIENT.get(`/coupons/${id}`);
};

export const UpdateCoupon = async (id, payload) => {
  const sanitizedPayload = buildPayload(payload);
  return API_CLIENT.patch(`/coupons/${id}`, sanitizedPayload);
};
